<script>
// import * as R from 'ramda'
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'
import CustomCheckbox from '@components/custom-checkbox'

export default {
  components: { CustomCheckbox },
  props: {
    demographics: { type: Array, default: () => [] },
    demographicsMap: { type: Array, default: () => [] },
    colors: { type: Array, default: () => ['#7cb5ec'] },
  },
  data() {
    return {
      demographicsInfos: [
        '<b>Low-income</b> - The count and percentage of students eligible for free or reduced-price lunch or eligible for other public assistance.',
        '<b>English Language Learners</b> – The count and percentage of students whose primary language is one other than English and who are in the process of acquiring English. The terms "English Language Learner," "English Learner," and "Limited English Proficient" (LEP) are used interchangeably.',
        '<b>At Risk</b> – The count and percentage of students identified as being at risk of dropping out of school as defined by TEC §29.081(d) and (d-1).',
      ],
      demographicOptions: this.demographics,
    }
  },
  computed: {
    // demographicOptions() {
    //   return this.demographics
    // },
    filterItemColors() {
      var colors = this.colors
      return _map(this.demographics, (val, index) => {
        return colors[index % colors.length]
      })
    },
    filterItemIds() {
      return _map(this.demographics, (val, index) => {
        return val.id
      })
    },
  },
  methods: {
    reset() {
      let that = this
      _forEach(this.demographicOptions, (item, index) => {
        item.checked = false
        that.$set(that.demographicOptions, index, item)
      })
      this.demographicOptions[0].checked = true
      this.$set(this.demographicOptions, 0, this.demographicOptions[0])
      this.$emit('reset')
    },
    selectAll() {
      _forEach(this.demographics, item => {
        item.checked = true
      })
      this.$emit('selectAll')
    },
    selectNone() {
      _forEach(this.demographics, item => {
        item.checked = false
      })
      this.$emit('selectNone')
    },
    toggleCheckbox(index) {
      this.demographics[index].checked = !this.demographics[index].checked
      this.$emit('updateFooter')
    },
  },
}
</script>

<template>
  <v-list class="custom-filter">
    <v-subheader class="reports-filters">Demographic
      <div>
        <div
          class="reset-btn"
          @click="reset">
          <v-btn
            small
            style="background-color: #243f92"
            falt>Reset</v-btn>
        </div>
        <v-menu
          :close-on-content-click="false"
          :nudge-width="300"
          :max-width="300"
          offset-x
          class="info-btn"
        >
          <v-btn
            slot="activator"
            icon
            class="mt-0 mb-0 mr-0"
            aria-label="Demographic definitions">
            <v-icon>info</v-icon>
          </v-btn>
          <v-card>
            <v-card-text
              v-for="(item,index) in demographicsInfos"
              :key="index"
              v-html="item"/>
          </v-card>
        </v-menu>
      </div>
    </v-subheader>
    <!-- <v-list-tile avatar>
      <v-list-tile-action class="right-action">
        <v-list-tile-sub-title><a
          class="a-select-color"
          @click="selectAll">Select All</a> | <a
            class="a-select-color"
            @click="selectNone">Select None</a></v-list-tile-sub-title>
      </v-list-tile-action>
    </v-list-tile>-->
    <li>
    <v-list-tile-content>
      <CustomCheckbox
        class="checkbox-label-color"
        v-for="(item,index) in demographicOptions"
        :data-id="filterItemIds[index]"
        :key="index"
        :label="demographicsMap[index]"
        :checked="item.checked"
        :color="filterItemColors[index]"
        @click="toggleCheckbox(index)"
      />
    </v-list-tile-content>
    </li>
  </v-list>
</template>

<style scoped>

label {
  color: rgb(112, 112, 112) !important;
}
.reports-filters {
  font-weight: bolder;
  font-size: 16px;
  font-size: 1.25rem;
  color: #707070;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  height: fit-content;
  margin-bottom: 5px;
  justify-content: space-between;
}
.reports-filters >>> .btn__content {
  color: #253e90;
}
.reports-filters >>> .btn__content::before {
  color: #0390c4;
  opacity: 0.5;
}
.info-btn :hover {
  cursor: pointer;
}
.right-action {
  position: absolute;
  right: 0px;
}
.custom-filter {
  position: relative;
}
.custom-filter >>> .list__tile {
  padding: 0px;
}
.custom-filter >>> .list__tile--avatar {
  height: 20px;
}
.a-select-color {
  color: rgba(0, 0, 0, 0.54);
}
.input-group label {
  height: 20px;
}
.reset-btn {
  display: inline-block;
}
.reset-btn >>> .btn__content {
  color: #ffffff;
  font-size: 14px;
  font-size: 1rem;
}
.reset-btn >>> .btn__content::before {
  color: inherit;
  opacity: 0.12;
}
.reset-btn >>> .btn {
  min-width: 58px;
}
.reset-btn >>> .btn--small {
  height: 22px;
}
</style>
